import axios from 'axios';
import {apiList} from './apiList';
import { store } from '../config/store';

const axiosInstance = axios.create({
  baseURL: apiList.baseUrl,
  //timeout: 10000,
});

axiosInstance.interceptors.request.use(config => {
  const {userInfo} = store.getState();
  if (userInfo && userInfo.token) {
    config.headers.Authorization = `Bearer ${userInfo.token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
